import { render, staticRenderFns } from "./price.vue?vue&type=template&id=1ec4dcb3&scoped=true&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"
import style0 from "./price.vue?vue&type=style&index=0&id=1ec4dcb3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4dcb3",
  null
  
)

export default component.exports